import { ISO_COUNTRY_CODES } from "src/app/constants";
import { Role } from "src/auth/types/interfaces";

// Country code type for WC claims filtering (ISO 3166-1 alpha-2)
export type CountryCode = "US" | "CA";

// Country option definitions for the country filter dropdown
export const COUNTRY_OPTIONS = [
  {
    label: "United States",
    value: ISO_COUNTRY_CODES.UNITED_STATES as CountryCode,
  },
  { label: "Canada", value: ISO_COUNTRY_CODES.CANADA as CountryCode },
] as const;

// Role to country code mapping
export const ROLE_TO_COUNTRY_MAP: Record<string, CountryCode | undefined> = {
  [Role.WC_CLAIM_USER]: ISO_COUNTRY_CODES.UNITED_STATES,
  [Role.WC_CLAIM_CANADA_USER]: ISO_COUNTRY_CODES.CANADA,
};
